import '../../css/base.css';

const Leaving = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Leaving</h2>
      <p className="your-stay-text">Changeover day is Friday. Please vacate the cottage by 10am.
                                    We kindly ask that you leave the cottage tidy and ready for cleaning.
                                    Please ensure you have washed, dried and put away all kitchen items.
                                    Please strip the beds and leave bedclothes in the laundry basket. You can
                                    find this in the utility room. Please place towels and bathmats in the laundry
                                    basket.  Finally don't forget to return the keys to the key safe before your departure.
      </p>                                            
    </div>
  );
}

export default Leaving;